import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appLogger } from '../../utils/datadog';
import { setRoomState, setRoomStateTransitioning } from '../../stores/actions/meeting';
import { GreenroomState as GS } from '../../stores/types/types';
import { RoomStates } from '../../types/enums';

const CurtainVid = require('../../images/curtain-transition.webm');

// UI elements are fully obscured by the video at this time and
// room state can be updated without the user seeing the UI change
const TRANSITION_TIME = 1;

export default function FullscreenTransition(): JSX.Element {
	const dispatch = useDispatch();
	const roomStateEntity = useSelector((s: GS) => s.MeetingReducer.roomStateEntity);
	const [roomStateUpdated, setRoomStateUpdated] = useState<boolean>(false);

	const newRoomState: number = useMemo(
		() => roomStateEntity?.entityValue.roomState ?? RoomStates.showbuilder,
		[roomStateEntity],
	);

	return (
		<div className="loading-fullscreen">
			<video
				onContextMenu={(e) => e.preventDefault()}
				controls={false}
				muted={true}
				autoPlay={true}
				onError={() => {
					appLogger.error('fullscreen-transition.tsx video error');
					dispatch(setRoomState(newRoomState));
					dispatch(setRoomStateTransitioning(false));
				}}
				onEnded={() => dispatch(setRoomStateTransitioning(false))}
				onTimeUpdate={(e) => {
					const vid = e.target as HTMLVideoElement;
					if (vid.currentTime >= TRANSITION_TIME && !roomStateUpdated) {
						setRoomStateUpdated(true);
						dispatch(setRoomState(newRoomState));
					}
				}}
			>
				<source src={CurtainVid} type="video/mp4"></source>
			</video>
		</div>
	);
}
